export default {
  list: {},
  ordersFetched: false,
  ordersLoading: false,
  archivedOrdersFetched: false,
  archivedOrdersLoading: false,
};
